/**
 * MENU CONFIGURATION
 * 
 * Define a estrutura visual do menu lateral.
 * Cada item tem:
 * - label: texto exibido
 * - icon: ícone MDI
 * - path: caminho da rota (sem tenant/branch prefix)
 * - permission: permissão necessária para ver este item (opcional)
 * - permissions: array de permissões (qualquer uma dá acesso)
 * - subItems: itens filhos (para menus expansíveis)
 * 
 * IMPORTANTE: Este arquivo NÃO importa componentes React.
 * O mapeamento path -> componente está em routeRegistry.js
 */

export const MENU_STRUCTURE = [
    { label: "Menu", isHeader: true },

    // ACESSO DIRETO
    {
        label: "Home",
        icon: "mdi mdi-home-outline",
        path: "/home"
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-view-dashboard-outline",
        subItems: [
            { label: "Operacional", path: "/dashboard" },
            { label: "Gerencial", path: "/dashboard/gerencial", permission: "dashboards_manager_view" },
            { label: "Financeiro", path: "/dashboard/financeiro", permission: "dashboards_financial_view" },
        ]
    },
    {
        label: "Grade",
        icon: "mdi mdi-calendar-clock",
        path: "/grade",
        permission: "grade_manage"
    },
    {
        label: "Clientes",
        icon: "mdi mdi-account-group-outline",
        path: "/members",
        permission: "members_manage"
    },

    // MÓDULOS AGRUPADOS 
    {
        label: "Administrativo",
        icon: "mdi mdi-briefcase-outline",
        subItems: [
            { label: "Turmas", path: "/management/classes", permission: "admin_classes" },
            { label: "Colaboradores", path: "/admin/employees", permission: "employees_manage" },
            { label: "Cargos", path: "/admin/roles", permission: "admin_roles" },
            { label: "Planos", path: "/admin/memberships", permission: "admin_memberships" },
            { label: "Produtos", path: "/admin/services", permission: "admin_catalog" },
            { label: "Áreas", path: "/admin/areas", permission: "admin_areas" },
            { label: "Níveis", path: "/admin/levels", permission: "management_evaluation_levels" },
        ]
    },
    {
        label: "Gerencial",
        icon: "mdi mdi-chart-areaspline",
        subItems: [
            { label: "CRM", path: "/crm", permission: "members_manage" },
            { label: "Experimentais", path: "/management/trials", permission: "members_manage" },
            { label: "Carteiras", path: "/admin/portfolio", permission: "admin_portfolio" },
            { label: "Auditoria", path: "/admin/audit-logs", permission: "management_audit_log" },
        ]
    },
    {
        label: "Técnico",
        icon: "mdi mdi-notebook-edit-outline",
        subItems: [
            { label: "Atividades", path: "/admin/activities", permission: "admin_activities" },
            { label: "Treinos", path: "/training/workouts", permission: "management_training_manage" },
            { label: "Planejamento", path: "/grade/planning", permission: "methodology_planning" },
            { label: "Avaliações", path: "/evaluation", permission: "management_evaluation_run" },
            { label: "Eventos", path: "/admin/events", permission: "admin_events" },
        ]
    },
    {
        label: "Financeiro",
        icon: "mdi mdi-cash-multiple",
        subItems: [
            { label: "Caixa", path: "/financial/cashier", permission: "financial_cashier" },
            { label: "Recebíveis", path: "/financial/receivables", permission: "financial_cashflow" },
            { label: "Pagáveis", path: "/financial/payables", permission: "financial_cashflow" },
            { label: "Fluxo de Caixa", path: "/financial/cash-flow", permission: "financial_cashflow" },
            { label: "Contas Bancárias", path: "/admin/bank-accounts", permission: "financial_cashflow" },
            { label: "Adquirentes", path: "/admin/acquirers", permission: "financial_acquirers" },
            { label: "Categorias DRE", path: "/admin/financial-categories", permission: "financial_cashflow" },
            { label: "DRE", path: "/financial/dre", permission: "financial_cashflow" },
        ]
    },
    {
        label: "Configurações",
        icon: "mdi mdi-cog-outline",
        subItems: [
            { label: "Dados da Empresa", path: "/settings/company", permission: "settings_company_manage" },
            { label: "Gamificação", path: "/settings/gamification", permission: "settings_gamification" },
            { label: "Automações", path: "/settings/automations", permission: "management_automations" },
            { label: "Regras de Negócio", path: "/settings/business-rules", permission: "management_automations" },
            { label: "Integrações", path: "/settings/integrations", permission: "management_integrations" },
            { label: "Importação", path: "/settings/import-members", permission: "settings_import" },
        ]
    },
    {
        label: "Quiosque",
        icon: "mdi mdi-monitor-dashboard",
        path: "/kiosk",
        permission: "kiosk_access"
    }
]
